import { render, staticRenderFns } from "./VectorStatsList.vue?vue&type=template&id=da701f4a&"
import script from "./VectorStatsList.vue?vue&type=script&lang=js&"
export * from "./VectorStatsList.vue?vue&type=script&lang=js&"
import style0 from "./VectorStatsList.vue?vue&type=style&index=0&id=da701f4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports